import { translateLabel } from "@/i18n/messages";
const titleCase = (value) => String(value || "")
  .replace(/_/g, " ")
  .toLowerCase()
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

const includesIgnoreCase = (values, wanted) =>
  (values || []).some((value) => String(value).toLowerCase() === String(wanted).toLowerCase());

export const buildDiscoveryResultEvidence = (park, criteria = {}, preferences = {}) => {
  const matches = [];
  const preferenceMatches = [];
  const warnings = [];

  if (criteria.radius && park.distance_km != null) {
    matches.push(translateLabel("{distance} km from the selected origin (within {radius} km)", { distance: Math.round(park.distance_km), radius: criteria.radius }));
  }
  if (criteria.type && criteria.type !== "everything" && String(park.type || "").toLowerCase().includes(criteria.type.replace("trailcenter", "trail center"))) {
    matches.push(translateLabel("Destination type: {type}", { type: translateLabel(titleCase(criteria.type)) }));
  }
  for (const access of criteria.access || []) {
    if (includesIgnoreCase(park.access, access)) {
      matches.push(access === "lift" ? translateLabel("Lift access is listed") : translateLabel("{access} access is listed", { access: translateLabel(titleCase(access)) }));
    }
  }
  for (const style of criteria.styles || []) {
    if (includesIgnoreCase(park.riding_styles, style)) matches.push(translateLabel("{style} riding is listed", { style: translateLabel(titleCase(style)) }));
  }
  for (const difficulty of criteria.difficulty || []) {
    const key = String(difficulty).toUpperCase();
    const count = park.difficulty_distribution?.[key.toLowerCase()] ?? park.difficulty_distribution?.[key] ?? 0;
    if (count > 0) matches.push(translateLabel(count === 1 ? "{count} {difficulty} trail in the catalogue" : "{count} {difficulty} trails in the catalogue", { count, difficulty: translateLabel(titleCase(difficulty)) }));
  }
  if (criteria.minTrails && park.trail_count >= criteria.minTrails) {
    matches.push(translateLabel("{count} trails in the catalogue (minimum {minimum})", { count: park.trail_count, minimum: criteria.minTrails }));
    warnings.push(translateLabel("Catalogue trail count is not the number of trails currently open."));
  }
  if (criteria.minRating && park.rating_count > 0 && Number(park.rating) >= criteria.minRating) {
    matches.push(translateLabel("Rating {rating} meets the {minimum}+ filter", { rating: Number(park.rating).toFixed(1), minimum: criteria.minRating }));
  }
  if (criteria.openNow && park.current_status === "OPEN_NOW") matches.push(translateLabel("Verified schedule indicates open now"));

  for (const access of preferences.access || []) {
    if (includesIgnoreCase(park.access, access)) preferenceMatches.push(access === "lift" ? translateLabel("Preferred lift access is listed") : translateLabel("Preferred {access} access is listed", { access: translateLabel(titleCase(access)) }));
  }
  for (const style of preferences.styles || []) {
    if (includesIgnoreCase(park.riding_styles, style)) preferenceMatches.push(translateLabel("Preferred {style} riding is listed", { style: translateLabel(titleCase(style)) }));
  }

  for (const warning of park.ai_warnings || []) warnings.push(warning);
  if (park.ai_want_match_status === "POSSIBLE") warnings.push(translateLabel("Some requested trail-trait metadata is incomplete."));

  const advancedReasons = (park.ai_decision_reasons || []).filter(Boolean);
  const allMatches = advancedReasons.length ? advancedReasons : matches;

  return {
    matches: [...new Set(allMatches)],
    preferenceMatches: [...new Set(preferenceMatches)],
    warnings: [...new Set(warnings)],
  };
};
